function getIsProduction() {
  return !!process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT?.includes('production')
}

export default getIsProduction
